export default __webpack_public_path__ + "static/media/Taco Page.ad180e4d.png";